export const isImageUrl = (text: string): boolean => {
  if (!text) return false;
  const urlRegex = /(https?:\/\/[^\s]+\.(?:jpg|jpeg|gif|png))/gi;
  return urlRegex.test(text);
};

export const extractImageUrls = (text: string): string[] => {
  if (!text) return [];
  const urlRegex = /(https?:\/\/[^\s]+\.(?:jpg|jpeg|gif|png))/gi;
  return text.match(urlRegex) || [];
};